import styled from 'styled-components';

import { BaseButton } from './base-primitives.styles';
import { rubikTypographyStyles } from './typography.styles';

export const PrimaryButton = styled(BaseButton)`
  ${rubikTypographyStyles};
  width: ${({ theme }) => theme.scale.px(331)};
  min-height: ${({ theme }) => theme.scale.px(56)};
  border-radius: ${({ theme }) => theme.scale.px(10)};
  background: ${({ theme }) => theme.colors.brand.primary};
  font-size: ${({ theme }) => theme.scale.px(15)};
  font-weight: 600;
  line-height: 1.25;
`;
